export const blockIconsSocialPsychology = (
	<span className='material-symbols-outlined'>psychology</span>
);
